module.exports = __webpack_public_path__ + "img/warning.379f2b03.svg";